import SyDateTimepicker from "./sy-date-time-picker";

export default SyDateTimepicker;
